"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var IntegrationJob_1 = require("./IntegrationJob");
var IntegrationJobHistory = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement(react_1.default.Fragment, null, props.integrationTemplate
        ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } }, t("Script job history")),
            react_1.default.createElement("div", null, props.integrationJobs && props.integrationJobs.map(function (item) {
                return (react_1.default.createElement(IntegrationJob_1.IntegrationJobListEntry, { key: item.id, job: item }));
            })))) : react_1.default.createElement(react_1.default.Fragment, null, "Loading")));
};
exports.default = IntegrationJobHistory;
